import { COMPANY_SSO_ACTION_TYPE } from '../actions';

const initialState = {
  companySsoInfoId: null,
  companyId: '',
  callbackUrl: '',
  serviceProviderEntityId: '',
};

const ssoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_SSO_ACTION_TYPE.GET_COMPANY_SSO_PROVIDER_INFO:
    case COMPANY_SSO_ACTION_TYPE.GET_COMPANY_SSO_INFO:
    case COMPANY_SSO_ACTION_TYPE.CREATE_COMPANY_SSO_INFO:
      return { ...state, ...payload };

    case COMPANY_SSO_ACTION_TYPE.DELETE_COMPANY_SSO_INFO:
      return { ...state, companySsoInfoId: null, companyId: '' };

    default:
      return state;
  }
};

export default ssoReducer;
